import { Component, ChangeDetectionStrategy, Input, OnInit } from "@angular/core";
import { PopoverController } from "@ionic/angular/standalone";
import { IonContent } from "@ionic/angular/standalone";
import { DokaIcon } from "@doka/angular-core";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-select-icon",
  templateUrl: "./select-icon.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./select-icon.component.scss"],
  standalone: true,
  imports: [DokaIcon, IonContent, CommonModule],
})
export class SelectIconComponent implements OnInit {
  @Input("selectedIcon") selectedIcon: string;
  protected availableIcons: string[] = [
    "home",
    "account_balance",
    "apartment",
    "house",
    "store",
    "location_city",
    "location_away",
    "emoji_transportation",
    "things_to_do",
    "home_and_garden",
    "moving_ministry",
    "wifi_home",
    "factory",
    "precision_manufacturing",
    "cottage",
    "warehouse",
    "other_houses",
    "mop",
    "garage_home",
    "gite",
    "villa",
    "hardware",
    "garage_door",
    "construction",
    "build",
    "tools_power_drill",
    "carpenter",
    "handyman",
  ];

  constructor(private popoverCtrl: PopoverController) {}

  ngOnInit() {}

  selectIcon(icon: string) {
    this.popoverCtrl.dismiss(icon);
  }
}
